const Beacon = {
  init: () => {
    const supportButtons = document.querySelectorAll('.nav_link--support')
    supportButtons.forEach(el => {
      el.addEventListener('click', Beacon.supportButtonHandler)
    })
  },

  supportButtonHandler: evt => {
    evt.preventDefault()
    try {
      if (window.Forethought && typeof window.Forethought === 'function') {
        window.Forethought('widget', 'open')
      }
    } catch (err) {
      console.error('Error opening support widget:', err)
    }
  },
}

document.addEventListener('turbolinks:load', Beacon.init)
